import { appendLinkElement } from "../../utils";
import LocationOfTechnicalStations from "./LocationOfTechnicalStations";
appendLinkElement("https://unpkg.com/leaflet@1.7.1/dist/leaflet.css", {
    integrity: "sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==",
    crossOrigin: ""
});
export { LocationOfTechnicalStations };
//# sourceMappingURL=index.js.map